<div class="term-of-the-privacy">
  <p>
    {{ 'components.termOfThePrivacy.labels.labelPart1' | translate }}
    <app-link
      [displayText]="'components.termOfThePrivacy.labels.labelPart2' | translate"
      (click)="onClickPolicyLink()"
    ></app-link>
  </p>
</div>
